import {BruteForceGameConfig} from "../BruteForceGameConfig";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {BruteForceSound} from "../sound/BruteForceSound";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class BruteForceReelView extends PIXI.Container {

    private _reelID: number;
    private _isNudgeStacked: boolean = false;
    private _nudgeSymPosition: number = -2 // -1 to 5 values are being used as symbol position;
    private _nudgeSymHeight: number = 0;
    private _nudgeContainer: PIXI.Container;
    private _stickyNudgeContainer: PIXI.Container;
    private _scatterContainer: PIXI.Container;

    constructor(id: number) {
        super();
        this.name = "Reel " + id;
        this._reelID = id;
        this._nudgeContainer = new PIXI.Container();
        this._nudgeContainer.name = "Reel_" + id + "Nudge_Container";
        this._scatterContainer = new PIXI.Container();
        this._scatterContainer.name = "Reel_" + id + "Scatter_Container";
        this._stickyNudgeContainer = new PIXI.Container();
        this._stickyNudgeContainer.name = "Reel_" + id + "StickyNudge_Container";
        this.position.set(id * BruteForceGameConfig.symbolWidth, 0);
        this.addChild(this._nudgeContainer);
        this.addChild(this._scatterContainer);
        this.addChild(this._stickyNudgeContainer);
    }

    get isReelContainingFullNudge(): boolean {
        return this._isNudgeStacked;
    }

    set isReelContainingFullNudge(value: boolean) {
        this._isNudgeStacked = value;
    }

    get nudgeReelPos(): number {
        return this._nudgeSymPosition;
    }

    set nudgeReelPos(value: number) {
        this._nudgeSymPosition = value;
    }

    get nudgeHeight(): number {
        return this._nudgeSymHeight;
    }

    set nudgeHeight(value: number) {
        this._nudgeSymHeight = value;
    }

    get nudgeContainer(): PIXI.Container {
        return this._nudgeContainer;
    }

    get scatterContainer(): PIXI.Container {
        return this._scatterContainer;
    }

    get stickyContainer(): PIXI.Container {
        return this._stickyNudgeContainer;
    }

    public nudgeSparks(toNudgeDown: boolean, reelId: number, rowId: number): gsap.core.Timeline {
        const sparksTl: gsap.core.Timeline = gsap.timeline();
        const sparkFrames: TimelineSprite = new TimelineSprite((BruteForce.assetLoader.getTextures("nudgeSparksEffect")));
        sparkFrames.position.set(0, BruteForceGameConfig.reelSetPositionY + BruteForceGameConfig.symbolHeight * rowId + (toNudgeDown ? -50 : -115));
        sparkFrames.anchor.set(0.5, 0.5);
        sparkFrames.name = "nudgeSparksEffect";
        if (!toNudgeDown) {
            sparkFrames.scale.set(1.3, -1);
        } else {
            sparkFrames.scale.set(1.3, 1);
        }

        sparkFrames.visible = false;
        this.nudgeContainer.addChild(sparkFrames);
        sparksTl.add(<gsap.core.Timeline><unknown>sparkFrames.getAnimationAutoShowHide(), 0);
        sparksTl.add(() => {
            sparkFrames.destroy();
            this.nudgeContainer.removeChild(sparkFrames);
        });
        // console.log(sparksTl.totalDuration()); 0.6667
        return sparksTl;
    }

}